import { render, staticRenderFns } from "./groupAdd.vue?vue&type=template&id=0ac9edea"
import script from "./groupAdd.vue?vue&type=script&lang=ts"
export * from "./groupAdd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports